import moment, { Moment } from 'moment'

export const formatYMD = (date: string | Date) => {
  return moment(date).format('YYYY/MM/DD')
}

export const formatDMY = (date: string | Date) => {
  return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
}

export const formatDateSendRequest = (date: Moment | null) => {
  return moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD')
}

export const formatHour = (date: string | Date) => {
  return moment(date).format('HH:mm:ss')
}

export const formatHm = (date: string | Date) => {
  return moment(date).format('HH:mm')
}

export const formatMinutes = (minutes: number) => {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60

  return `${hours}:${mins.toString().padStart(2, '0')}`
}
